---
meta:
  - title: Como usar Redactor - IUSPRO Docs
  - description: Aprende a utilizar el redactor inteligente.
---

# Como usar Redactor

El Redactor es una herramienta para redactar documentos legales de cualquier tipo. Es extremadamente bueno redactando
documentos legales en Costa Rica.

## ¿Qué hace el Redactor?

El Redactor no usa plantillas fijas. En su lugar:

- Busca en los códigos (Procesal Civil, Civil, Penal, Procesal Penal, etc.)
- Extrae el formato del documento específico que se quiere directamente desde los códigos
- Identifica qué secciones debe tener y en qué orden
- Crea el documento según lo que dice el código actual

## Ventajas sobre plantillas tradicionales

- **No necesita actualizar plantillas**: La base de datos se actualiza cada 24 horas automáticamente
- **Siempre al día**: Cualquier documento que haga estará actualizado con la ley vigente
- **Personalizado**: No solo hace la plantilla, desarrolla argumentos y petitorios según su caso

## Tipos de documentos que puede crear

Puede hacer absolutamente de todo:

- **Documentos notariales**: Escrituras, nombramientos, amonestaciones
- **Documentos procesales sencillos**
- **Documentos complejos**: Demandas, contrademandas, querellas, recursos de casación
- Cualquier otro documento legal que necesite

## Formas de crear un documento

### 1. Comenzar con instrucciones

Simplemente dígale qué quiere:

```
"Redacta un recurso de casación con..."
"Necesito un interdicto de amparo de oposición..."
```

Mientras más contexto le dé sobre lo que quiere, mejor será el resultado.

### 1.1 Crear el documento dentro de un cliente

Si el documento pertenece a un cliente que ya tiene contexto cargado, conviene iniciarlo dentro de ese cliente.

Así el Redactor puede apoyarse en:

- instrucciones del cliente
- expedientes vinculados
- archivos del cliente

Esto es especialmente útil cuando va a redactar varios documentos relacionados entre sí.

### 2. Mejorar un borrador existente

- Suba un documento que ya tenga
- Pídale que lo mejore
- Puede pedirle que añada jurisprudencia específica

Por ejemplo, solo con decir **"añádeme jurisprudencia"**, él va a buscar:

- La mejor jurisprudencia reciente
- Cambios de criterio si los hay
- Criterios unificadores
- Jurisprudencia crucial para su caso

## Añadir citas específicas

Puede decirle que añada referencias específicas sin necesidad de escribir todo el artículo:

```
"Añade citas al Código Procesal Civil, artículo tal"
```

Él sabrá qué dice el código y lo incluirá correctamente.

## Mini chat para refinar el documento

Una vez creado el documento, tiene un mini asistente donde puede:

- "Añade tal cosa"
- "Expande tal argumento"
- "Expande tal petitoria"
- "Resume este párrafo"
- "Incluye más contexto"
- "Incluye menos contexto"
- "Descríbelo más"

El documento se va actualizando en tiempo real según sus instrucciones.

## Editar el documento

Puede editar directamente el texto del documento en la plataforma. Tiene control total sobre el contenido.

## Exportar el documento

Puede exportar su documento como:

- **PDF**
- **Word**

Una vez exportado, puede hacerle todos los cambios de formato que necesite.

## Rellenar datos automáticamente

Si tiene archivos con datos de un caso:

1. Suba el archivo con la información
2. Pídale "rellename los datos"
3. El Redactor completará todos los campos necesarios automáticamente

Esto es muy rápido y conveniente cuando tiene toda la información en un archivo.

## Cuándo usar cliente + Redactor

Use el Redactor con cliente cuando:

- el documento forma parte del trabajo continuo de un cliente
- ya tiene contexto ordenado en un cliente
- quiere mantener coherencia entre varios escritos

Si quiere profundizar en eso, vea [usar clientes en el redactor](/guias/redactor-usar-proyectos).
